import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { message: String }

  connect() {
    this.originalValue = this.inputTarget.value
  }

  confirmIfChanged(e) {
    if (!e.target.contains(this.inputTarget)) return
    if (this.originalValue === "" || this.inputTarget.value === this.originalValue) return

    if (!confirm(this.messageValue)) {
      e.preventDefault()
    }
  }
}
